<ion-header>
  <ion-toolbar>
    <ion-img alt="" class="brand-logo" src="assets/image/brand.png"></ion-img>
    <pkp-db-dumper class="db-dumper"></pkp-db-dumper>
    <pkp-dark-mode-toggle class="mr-32" *isNotMobile slot="end"></pkp-dark-mode-toggle>
    <ion-buttons slot="end" *isLoggedIn>
      <ion-menu-button fill="outline" color="primary"></ion-menu-button>
    </ion-buttons>
    <pkp-online-indicator class="online-indicator"></pkp-online-indicator>
  </ion-toolbar>
</ion-header>
